import { GET_ALL_LINKS, GET_LINK } from "../actions/actionTypes";

const initialState = {
  links: [],
  selectedLink: null,
};

export default function links(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_LINKS:
      return {
        ...state,
        links: action.payload || [],
      };
    case GET_LINK:
      return {
        ...state,
        selectedLink: action.payload,
      };
    default:
      return state;
  }
}
